import { render, staticRenderFns } from "./WhatsAppConfirmationModal.vue?vue&type=template&id=70dd720e&scoped=true&"
import script from "./WhatsAppConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./WhatsAppConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./WhatsAppConfirmationModal.vue?vue&type=style&index=0&id=70dd720e&scoped=true&lang=scss&"
import style1 from "./WhatsAppConfirmationModal.vue?vue&type=style&index=1&id=70dd720e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd720e",
  null
  
)

export default component.exports